import { exhaustiveFail } from '@cbridge-utils/error';
import {
  IApiClient, ApiClientType, IApiMTPricingClientSettingsBase, IApiMTTradingClientSettingsBase, IApiUpdateClientReq,
} from '@cbridge-packages/api';
import { IClient, ClientType, IPricingClientSettings, ITradingClientSettings, IClientUpdate } from './client.interface';

export namespace ClientTranslator {
  export function fromApi(client: IApiClient): IClient {
    return {
      clientId: client.id,
      name: client.name,
      type: ClientTranslator.fromApiClientType(client.type),
      enabled: client.enabled,
    };
  }

  export function fromApiClientType(type: ApiClientType): ClientType {
    switch (type) {
      case ApiClientType.Pricing:
        return ClientType.Pricing;
      case ApiClientType.Trading:
        return ClientType.Trading;
      default:
        return exhaustiveFail(type);
    }
  }

  export const fromApiPricingSettings = (settings: IApiMTPricingClientSettingsBase): IPricingClientSettings => {
    if (!settings) {
      return undefined;
    }

    return settings as IPricingClientSettings;
  };

  export const fromApiTradingSettings = (settings: IApiMTTradingClientSettingsBase): ITradingClientSettings => {
    if (!settings) {
      return undefined;
    }

    return settings as ITradingClientSettings;
  };

  export function toApi(client: IClientUpdate): IApiUpdateClientReq {
    return {
      clientId: client.clientId,
      enabled: client.enabled,
      settings: ClientTranslator.toApiClientSettings(client.settings),
    };
  }

  function isTradingSettings(obj: IPricingClientSettings | ITradingClientSettings): obj is ITradingClientSettings {
    return 'groups' in obj || 'rejectClientRequestIfOffline' in obj;
  }

  export const toApiClientSettings = (settings: IClientUpdate['settings']): IApiUpdateClientReq['settings'] => {
    if (!settings) {
      return undefined;
    }

    if (isTradingSettings(settings)) {
      return ClientTranslator.toApiTradingSettings(settings);
    }

    return ClientTranslator.toApiPricingSettings(settings);
  };

  export const toApiPricingSettings = (settings: IPricingClientSettings): IApiMTPricingClientSettingsBase => {
    if (!settings) {
      return undefined;
    }

    return settings as IApiMTPricingClientSettingsBase;
  };

  export const toApiTradingSettings = (settings: ITradingClientSettings): IApiMTTradingClientSettingsBase => {
    if (!settings) {
      return undefined;
    }

    return settings as IApiMTTradingClientSettingsBase;
  };
}
